class InvariantError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, InvariantError.prototype);
    }
}
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(typeof message === 'function' ? message() : message);
    }
}

const isBoxed = (entity) => {
    return '__boxed' in entity;
};
const boxData = (entity, boxedValue) => {
    return Object.assign(Object.assign({}, entity), { __boxed: boxedValue });
};
const unboxData = (entity) => {
    return entity.__boxed;
};
const assertIfNotBoxed = (entity) => {
    invariant(isBoxed(entity), `Entity is not boxed`);
};

function assertUnreachable(_value, message) {
    throw new Error(message);
}

const getNestedObjectValue = (obj, path) => {
    if (path.length === 0)
        return undefined;
    return path.reduce((currentObj, key) => {
        return currentObj && currentObj[key] !== undefined ? currentObj[key] : undefined;
    }, obj);
};
const mapNestedObjectValues = (obj, fn) => {
    if (typeof obj !== 'object' || obj === null) {
        return fn(obj);
    }
    return Object.entries(obj).reduce((acc, [key, value]) => {
        acc[key] = mapNestedObjectValues(value, fn);
        return acc;
    }, structuredClone(obj));
};

export { InvariantError, assertIfNotBoxed, assertUnreachable, boxData, getNestedObjectValue, invariant, isBoxed, mapNestedObjectValues, unboxData };
//# sourceMappingURL=bundle.mjs.map
